import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { IPhoneCode } from './phone-input.interface';
declare const require: any;

@Component({
    selector: 'app-phone-input',
    templateUrl: './phone-input.component.html',
    styleUrls: ['./phone-input.component.scss'],
    standalone: false
})
export class PhoneInputComponent implements OnInit {

  /** หากว่าต้องการตัวช่วยในการพิมพ์เบอร์โทร */
  @Input('hasMask') hasMask: boolean = true;

  /** phone code */
  @Input('code') code?: AbstractControl | null;

  /** phone number */
  @Input('phone') phone?: AbstractControl | null;

  /** รายการข้อมูลรหัสเบอร์โทร */
  codes: Array<IPhoneCode> = require('./phone-input.resource.json');

  constructor() {
    // รหัสใน resource เก็บเป็น "+66" แต่ค่าในฟอร์ม/แบ็กเอนด์ใช้ "66" (ไม่มี +) จึงตัด + ออกให้ตรงกัน
    this.codes = this.codes.map(c => ({ ...c, number: (c.number || '').replace('+', '') }));
    this.codes.sort((a, b) => a.number.localeCompare(b.number));
  }

  ngOnInit(): void {
  }

  /** code form */
  get getCodeControl() { return this.code as UntypedFormControl; }

  /** phone form */
  get getPhoneControl() { return this.phone as UntypedFormControl; }

  /** get mask */
  get getMask() {
    if (this.code) {
      const value = this.code.value;
      const code = this.codes.find(m => m.number == value);
      if (code && code.mask) return code.mask;
    }
    return "9999999999";
  }
}
